import * as React from "react";
const MoneyCoins = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M70.7 90.5c12.979 0 23.5-10.521 23.5-23.5S83.68 43.5 70.7 43.5 47.2 54.021 47.2 67s10.521 23.5 23.5 23.5" })),
    React.createElement("mask", { id: "prefix__b", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__b)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M63.6 4.9H8.8V16h54.8z" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M63.6 16H8.8v11.1h54.8zM63.6 38.3H8.8v11.1h54.8zM63.6 60.5H8.8v11.1h54.8z" }),
        React.createElement("path", { fill: "#CFCFCF", d: "M55.8 27.1H1v11.1h54.8zM74.7 49.4H19.9v11.1h54.8z" })),
    React.createElement("mask", { id: "prefix__c", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__c)" },
        React.createElement("path", { fill: "#ED0000", d: "M55.6 94.4c12.979 0 23.5-10.52 23.5-23.5 0-12.978-10.521-23.5-23.5-23.5S32.1 57.922 32.1 70.9c0 12.98 10.521 23.5 23.5 23.5" }))));
export default MoneyCoins;
//# sourceMappingURL=MoneyCoins.js.map